<script setup lang="ts">
import {NotificationTemplate} from "@/notification-template/interfaces";
import RCSView from "@/notification-template/components/rcs/RCSView.vue";

defineProps<{
    template: NotificationTemplate
}>();
</script>

<template>
  <div class="flex flex-col">
    <RCSView v-if="template.rcs_payload" :payload="template.rcs_payload" />
    <p v-if="template.type === 'rcs_flow'" class="text-xs text-primary self-center">
      Séquence à messages multiples
    </p>
  </div>
</template>
